import {Field, Formik} from 'formik';
import * as React from 'react';
import {useState} from 'react';
import {Link} from 'react-router-dom';
import * as Yup from 'yup';
import {Button} from '~/components/Button';
import {InputType} from '~/components/Controls/Input';
import {Form, InputField, IntentText} from '~/components/Form';
import {InfoWrapper} from '~/components/Layout';
import {Progress} from '~/components/Progress';
import {Intent} from '~/lib/intent';
import {recoveryPassword} from '~/modules/Profile/api';
import style from './../../index.module.scss';

interface IRecoveryParams {
    email: string;
}

const RecoverySchema = Yup.object().shape<IRecoveryParams>({
    email: Yup.string().email('Invalid email').required('Required')
});

const recoveryParamsDefault: IRecoveryParams = {
    email: ''
};

export const RequestView = () => {
    let [instructionsSent, setInstructionsSent] = useState(false);
    return <InfoWrapper links={[
        <Link key='sign-in' to='/sign-in'>Sign In</Link>
    ]}
    >
        <Formik
            initialValues={recoveryParamsDefault}
            validationSchema={RecoverySchema}
            onSubmit={(values, actions) => {
                recoveryPassword(values.email).then(() => {
                    setInstructionsSent(true);
                }).catch(error => {
                    actions.setStatus(error.response.data.message);
                    actions.setSubmitting(false);
                });
            }}
        >
            {(form) => <Form>
                {instructionsSent ? <div className={style.formSimple}>
                        You will receive an email with instructions on how to reset your password in a few minutes
                </div>
                    : <>
                        <div className={style.formSimple}>
                            {form.status && <IntentText className={style.formStatus}>{form.status}</IntentText>}
                            <Field name='email'
                                label='Email'
                                options={{
                                    type: InputType.EMAIL,
                                    placeholder: 'Email',
                                    leftIcon: <i className='fa fa-user'/>,
                                    disabled: form.isSubmitting
                                }}
                                className={style.simpleField}
                                component={InputField}
                            />
                        </div>
                        <div>
                            <Button type='submit' disabled={form.isSubmitting} intent={Intent.PRIMARY}>{form.isSubmitting ?
                                <Progress/> :
                                'Recover'}</Button>
                        </div>
                    </>}
            </Form>}
        </Formik>
    </InfoWrapper>;
};
